import React from 'react'

export default function ArrowRightHeaderPopUp() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M6.66665 2.70832C6.83254 2.70753 6.99174 2.77362 7.10831 2.89165L13.775 9.55832C14.0187 9.80233 14.0187 10.1976 13.775 10.4417L7.10831 17.1083C6.86206 17.3378 6.47831 17.331 6.2403 17.093C6.00229 16.855 5.99551 16.4712 6.22498 16.225L12.45 9.99998L6.22498 3.77498C5.98127 3.53097 5.98127 3.13567 6.22498 2.89165C6.34155 2.77362 6.50076 2.70753 6.66665 2.70832Z" fill="black"/>
    </svg>
  )
}
